import { API_STAT_UNITS } from '../../../../utils/constants/api';

export const HAVOC_SUMMARY_TOTALS = {
  PLAYS: {
    playCount: {
      key: 'playCount',
      label: 'Plays',
      units: API_STAT_UNITS.COUNT,
    },
    runRate: {
      key: 'runRate',
      label: 'Run%',
      units: API_STAT_UNITS.PERCENTAGE,
    },
    runPlays: {
      key: 'runPlays',
      label: 'Run Plays',
      units: API_STAT_UNITS.COUNT,
    },
    passPlays: {
      key: 'passPlays',
      label: 'Pass Plays',
      units: API_STAT_UNITS.COUNT,
    },
  },
  HAVOC: {
    havocPlays: {
      key: 'havocPlays',
      label: 'Havoc Plays',
      units: API_STAT_UNITS.COUNT,
    },
    // havocEvents: {
    //   key: 'havocEvents',
    //   label: 'Havoc Events Zoned',
    //   units: API_STAT_UNITS.COUNT,
    // },
    havocEventsAll: {
      key: 'havocEventsAll',
      label: 'Havoc Events',
      units: API_STAT_UNITS.COUNT,
    },
  },
  SELECTED: {
    havocPlays: {
      key: 'havocPlays',
      label: 'Selected Plays',
      units: API_STAT_UNITS.COUNT,
    },
    havocEvents: {
      key: 'havocEvents',
      label: 'Selected Events',
      units: API_STAT_UNITS.COUNT,
    },
  },
};
